import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import MUITextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import _get from 'lodash/get';
import _debounce from 'lodash/debounce';
import moment from 'moment';
import { withNamespaces } from 'react-i18next';

import _isFunction from 'lodash/isFunction';
import _isEqual from 'lodash/isEqual';
import FormikPropsValidations from './FormikPropsValidations';
import TextFieldStyles from './TextField.styles';
import FieldValidationPopup from '../Poppers/FieldValidation';
//import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { TimePicker } from 'material-ui-time-picker';
import _isEmpty from 'lodash/isEmpty';
import combineStyles from '../../../utils/combineStyles';
const { Button, Dialog, DialogActions } = require('@material-ui/core');

const styles = () => ({
  timeIcon: {
    color: 'rgba(0, 0, 0, 0.54)'
  }
});
export class TimeField extends Component {
  static propTypes = {
    name: props => FormikPropsValidations('name', props),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), //This is a duration in seconds from midnight
    label: PropTypes.string,
    onChange: props => FormikPropsValidations('onChange', props),
    validateField: PropTypes.func,
    classes: PropTypes.object,
    placeholder: PropTypes.string,
    form: PropTypes.object
  };
  //Display value is what we show on the screen
  componentDidMount() {
    this._setFieldError();
  }
  constructor(props) {
    super(props);
    const debounceDelay = props.debounce ? props.debounce : 700;
    this.syncChange = _debounce(this.syncChange, debounceDelay);
    this.state = {
      value: props.value || '',
      anchorEl: null,
      fieldError: '',
      timePickerInput: '',
      displayTimePicker: false,
      fieldName: this.props.name || _get(this.props, 'field.name'),
      displayValue: props.value
        ? this._getTimeFromSecondsFromMidnight(props.value)
        : ''
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { form: currentForm = {} } = this.props;
    const { errors: currentErrors = {} } = currentForm;
    const { form = {} } = nextProps;
    const { errors = {} } = form;

    if (!_isEqual(currentErrors, errors)) {
      return true;
    }

    if (
      nextProps.value !== this.props.value ||
      !_isEqual(this.state, nextState)
    ) {
      return true;
    } else {
      return false;
    }
  }
  _setFieldError = () => {
    const { fieldName } = this.state;
    const { form = {} } = this.props;
    const { errors } = form;
    const error = _get(errors, fieldName, '');
    this.setState({ fieldError: error });
  };
  componentDidUpdate(prevProps) {
    const { validateField } = this.props;
    const { fieldName } = this.state;
    if (_get(prevProps, 'form.errors') !== _get(this.props, 'form.errors')) {
      this._setFieldError();
    }

    if (prevProps.value !== this.props.value) {
      if (_isFunction(validateField)) {
        validateField(fieldName, this.props.value);
      }

      this.setState({
        value: this.props.value || '',
        displayValue: this.props.value
          ? this._getTimeFromSecondsFromMidnight(this.props.value)
          : ''
      });
    }
  }

  syncChange = e => {
    this._handleChange(e);
  };

  _handleTimePickerChange = timePickerInput => {
    this.setState({ timePickerInput });
  };
  _commitTimePickerTime = () => {
    const { timePickerInput, fieldName } = this.state;
    const { validateField, field = {} } = this.props;
    const onChange = this.props.onChange || field.onChange;
    const timeStamp = moment(timePickerInput);
    const formValue = this._getSecondsFromMidnight(timeStamp);
    const displayValue = timeStamp.format('h:mm A');

    this.setState({
      displayValue,
      displayTimePicker: false,
      timePickerInput: ''
    });

    onChange({ target: { name: fieldName, value: formValue } });

    if (_isFunction(validateField)) {
      validateField(fieldName, formValue);
    }
  };

  _handleResetField = () => {
    const { field = {} } = this.props;

    const onChange = this.props.onChange || field.onChange;

    this.setState({ value: '' });
    onChange({ target: { name: this.state.name, value: '' } });
  };
  _handleShowError = event => {
    const { fieldError } = this.state;
    if (fieldError) {
      this.setState({ anchorEl: event.currentTarget });
    }
  };
  _handleHideError = () => {
    this.setState({ anchorEl: null });
  };
  _toggleTimeModal = () => {
    const { displayTimePicker } = this.state;
    this.setState({ displayTimePicker: !displayTimePicker });
  };
  _formatTimeDuration = date => {
    const { savingFormat = null } = this.props;
    const value = savingFormat
      ? date.format(savingFormat)
      : this._getSecondsFromMidnight(date);
    return value;
  };
  _getSecondsFromMidnight = date => {
    const mmtMidnight = date.clone().startOf('day');
    return date.diff(mmtMidnight, 'seconds');
  };

  _getTimeFromSecondsFromMidnight = secondsFromMidnight => {
    const duration = moment.duration(secondsFromMidnight, 'seconds');
    const timeStamp = moment()
      .startOf('day')
      .hours(duration.hours())
      .minutes(duration.minutes())
      .seconds(duration.seconds());
    return timeStamp.format('h:mm A');
  };
  _handleChange = ({ target: { value } }) => {
    this.setState({ displayValue: value });
  };
  _handleBlur = ({ target: { value } }) => {
    const { validateField, field = {} } = this.props;
    const onChange = this.props.onChange || field.onChange;
    const { fieldName } = this.state;
    const regex = /\d{1,2}(:\d{1,2})?\s?(am|pm)?/gim;
    const withSeconds = 1;
    const withAMPM = 2;
    let format = '';
    let formValue = null;
    const matches = regex.exec(value);

    if (matches) {
      //lets figure out the format
      if (matches[withSeconds] && matches[withAMPM]) {
        //11:00 am
        format = 'HH:mm A';
      }
      if (!_isEmpty(matches[withSeconds]) && _isEmpty(matches[withAMPM])) {
        //11:00
        format = 'HH:mm';
      }
      if (_isEmpty(matches[withSeconds]) && !_isEmpty(matches[withAMPM])) {
        format = 'HH A'; //11 am
      }
      if (format === '') {
        format = 'H'; //23
      }

      const timeStamp = moment(value, format);
      if (timeStamp.isValid()) {
        formValue = this._getSecondsFromMidnight(timeStamp);
      }
      this.setState({
        value: formValue,
        displayValue: formValue
          ? this._getTimeFromSecondsFromMidnight(formValue)
          : ''
      });
    }

    onChange({ target: { name: fieldName, value: formValue } });

    setTimeout(() => {
      if (_isFunction(validateField) && !this.state.displayTimePicker) {
        validateField(fieldName, formValue);
      }
    }, 1000); //This is done because if you validate right when you blur, the time picker could be open at the moment
  };

  render() {
    const { classes, label, type = 'text', placeholder = null, t } = this.props;
    const {
      fieldName,
      fieldError,
      anchorEl,
      displayValue,
      displayTimePicker
    } = this.state;

    /* Uncomment to enable a time picker for mobile
    const endAdornmentContent = (
      <AccessTimeIcon
        onClick={this._toggleTimeModal}
        classes={{ root: classes.timeIcon }}
      />
    ); */
    const inputProps = {
      type,
      className: classnames(
        classes.inputBaseRoot,
        classes.inputBaseRootWidthEndAddorment
      )
    };
    const endAdornmentContent = null;
    return (
      <Fragment>
        <MUITextField
          id="outlined-name"
          className={classnames(classes.textField, classes.root)}
          variant="outlined"
          classes={{
            root: classes.root
          }}
          name={fieldName}
          value={displayValue}
          label={label}
          onChange={this._handleChange}
          onBlur={this._handleBlur}
          onMouseEnter={this._handleShowError}
          onFocus={this._handleShowError}
          onMouseOut={this._handleHideError}
          InputProps={{
            endAdornment: endAdornmentContent ? (
              <InputAdornment position="end">
                {endAdornmentContent}
              </InputAdornment>
            ) : null
          }}
          InputLabelProps={{
            classes: {
              root: classes.label
            }
          }}
          // eslint-disable-next-line
          inputProps={inputProps}
          FormHelperTextProps={{
            classes: {
              root: classes.formHelperTextRoot
            }
          }}
          error={!!fieldError}
          placeholder={placeholder}
        />
        <FieldValidationPopup anchorEl={anchorEl} message={fieldError} />
        <Dialog maxWidth="xs" open={displayTimePicker}>
          <TimePicker mode="12h" onChange={this._handleTimePickerChange} />
          <DialogActions>
            <Button onClick={() => this._toggleTimeModal()} color="primary">
              {t('Cancel')}
            </Button>
            <Button onClick={this._commitTimePickerTime} color="primary">
              {t('Ok')}
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}
const translatedTimeField = withNamespaces()(TimeField);
export default withStyles(combineStyles(styles, TextFieldStyles))(
  translatedTimeField
);
